import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { Modal, ModalCTA } from 'containers/misc'
import { LogAdd, LogEdit } from 'containers/forms/logs'
import { Title, Section } from 'components/layout'
import { Button } from 'components/misc'
import { ActivityLogsList } from 'components/sections/activities'
import { modal, updateAccordion } from 'redux/modules/app'
import { apiActivities } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS, LEVELS, PROGRESS_STATES } from 'constants/enums'

const enhance = compose(
  apiActivities(
    {
      updateParticipantDetails: true,
      activityLogs: true,
      updateLogs: true,
      updateParticipantAward: true
    },
    connect(null, { modal, updateAccordion })
  )
)

class Logs extends Component {
  static propTypes = {
    activityId: PropTypes.number.isRequired,
    activities: PropTypes.object.isRequired,
    activityState: PropTypes.object,
    isParentLoading: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    // updateAccordion: PropTypes.func.isRequired,
    getActivityLog: PropTypes.func.isRequired,
    createActivityLog: PropTypes.func.isRequired,
    removeActivityLog: PropTypes.func.isRequired,
    editActivityLog: PropTypes.func.isRequired,
    onRestoreActivityLog: PropTypes.func.isRequired,
    award: PropTypes.object.isRequired,
    isMessagingEnabled: PropTypes.bool.isRequired,
    configuration: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      limit: 5,
      loadLimit: 5,
      deleteDialog: false,
      logToRemoveId: null,
      removeLogSet: false
    }
  }

  handleAddLog = () => this.props.modal(`modal-add-log-${this.key}`)

  handleEditLog = (id, disabled) => {
    if (disabled) {
      return
    }

    this.props.getActivityLog(id).then(() => {
      this.props.modal(`modal-edit-log-${this.key}`)
    })
  }

  handleClose = () => {
    this.handleRemoveClose()
    this.props.modal(null)
  }

  handleRemoveOpen = (logToRemoveId, removeLogSet) =>
    this.setState({ deleteDialog: true, logToRemoveId, removeLogSet })

  handleRemoveClose = () =>
    this.setState({ deleteDialog: false, logToRemoveId: null })

  getBulkLogsForAward = (awardLevel, orgId) => {
    switch(awardLevel){

      case LEVELS.BRONZE.value: return get(this.props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id}].booleanValue`)
      case LEVELS.SILVER.value: return get(this.props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id}].booleanValue`)
      case LEVELS.GOLD.value: return get(this.props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id}].booleanValue`)
      default: return false
    }
  }

  render() {
    const {
      activities: { logs: { listsByActivityId } },
      activityState,
      createActivityLog,
      editActivityLog,
      activityId,
      activities,
      isParentLoading,
      onRestoreActivityLog,
      isMessagingEnabled,
      award,
      configuration
    } = this.props
    const { deleteDialog, logToRemoveId, removeLogSet } = this.state
    const canEdit =
      get(activityState, 'value') !== PROGRESS_STATES.activitySetup.id &&
      get(activityState, 'value') !==
        PROGRESS_STATES.activityLeaderSignoff.id &&
      get(activityState, 'value') !== PROGRESS_STATES.activityOfficeSignoff.id

    const orgId = get(award, 'organization.id')

    const awardLevel = get(award, 'awardLevel.value')

    const isBulkLogsEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isBulkLogsEnabled.id}].booleanValue`)

    const isBulkLogsForAwardEnabled = this.getBulkLogsForAward(awardLevel, orgId)

    return (
      <Section loading={activities.loading && !isParentLoading}>
        <div className="row" style={{ marginBottom: '20px' }}>
          <div className="col-xs-12 text--right">
            {canEdit &&
            <Button type="button" onClick={this.handleAddLog} secondary>
              <FormattedMessage
                  id="button.add_log"
                  defaultMessage="Add log"
              />
            </Button>}
          </div>
        </div>
          <ActivityLogsList
              logs={listsByActivityId[activityId]}
              // limit={limit}
              onLogClick={this.handleEditLog}
              disabled={!canEdit}
              award={award}
              isMessagingEnabled={isMessagingEnabled}
              activityState={activityState}
          />
        <Modal id={`modal-edit-log-${this.key}`} customActions enableOverflow>
          <LogEdit
            editActivityLog={editActivityLog}
            log={activities.activityLog}
            onClose={this.handleClose}
            onRemove={this.handleRemoveOpen}
            onRestore={onRestoreActivityLog}
            disabled={!canEdit}
            isBulkLogsEnabled={isBulkLogsEnabled}
            isBulkLogsForAwardEnabled={isBulkLogsForAwardEnabled}
          />
          {deleteDialog &&
            <ModalCTA>
              <Title
                h2
                className="text--center"
                intlKey="moduleTitle.would_you_like_to_remove_this_log"
              >
                Would you like to delete this log?
              </Title>
              <div className="row">
                <div className="col-xs-6">
                  <Button
                    type="button"
                    onClick={this.handleRemoveClose}
                    secondary
                    intlKey="button.close"
                  >
                    Close
                  </Button>
                </div>
                <div className="col-xs-6 text--right">
                  <Button
                    type="button"
                    negative
                    intlKey="button.confirm"
                    onClick={() => {
                      this.props
                        .removeActivityLog(logToRemoveId, removeLogSet)
                        .then(() => this.handleRemoveClose())
                    }}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </ModalCTA>}
        </Modal>
        <Modal id={`modal-add-log-${this.key}`} customActions enableOverflow>
          <LogAdd
            createActivityLog={createActivityLog}
            activityId={activityId}
            onClose={this.handleClose}
            disabled={!canEdit}
          />
        </Modal>
      </Section>
    )
  }
}
export default enhance(Logs)
